import type { TView } from '../models';

type TKinds = 'red' | 'stroke' | 'grey' | 'pseudo' | 'blue' | 'translucent' | 'webviewblack';

export const colorsMap: Record<string, TView> = {
    red: 'primary',
    stroke: 'tertiary',
    grey: 'secondary',
    pseudo: 'primary',
    blue: 'primary',
    translucent: 'secondary',
    webviewblack: 'primary',
};

/**
 * TODO: Удалить после прекращения использования (@alfa-site/site-security-warranty-block, @alfa-site/site-invest-open-account).
 * @deprecated Принимает значения как kind, так и view и возвращает view или undefined
 */
export const getButtonViewByKind = (buttonKind?: TKinds | TView | string): TView | undefined => {
    if (!buttonKind) return;

    return colorsMap[buttonKind] ?? (buttonKind as TView);
};
